module.exports = __webpack_public_path__ + "static/media/Climate_ADAPT_logo.56f59520.svg";